import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { RequireAuth } from "@/components/RequireAuth";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Forum from "@/pages/Forum";
import ThreadDetail from "@/pages/ThreadDetail";
import Admin from "@/pages/Admin";
import HyenaDungeon from "@/pages/HyenaDungeon";
import AdminHyenaDungeon from "@/pages/AdminHyenaDungeon";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route
              path="/forum"
              element={
                <RequireAuth>
                  <Forum />
                </RequireAuth>
              }
            />
            <Route
              path="/forum/threads/:id"
              element={
                <RequireAuth>
                  <ThreadDetail />
                </RequireAuth>
              }
            />
            <Route path="/hyena-dungeon" element={<HyenaDungeon />} />
            <Route
              path="/admin/hyena-dungeon"
              element={
                <RequireAuth roles={["admin"]}>
                  <AdminHyenaDungeon />
                </RequireAuth>
              }
            />
            <Route
              path="/admin"
              element={
                <RequireAuth roles={["admin"]}>
                  <Admin />
                </RequireAuth>
              }
            />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
